import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import styles from './styles';
import TableColumns from './TableColumns';
import { fetchLogs } from 'utils/loggingUtils';
import TableContainer from '../../Containers/TableContainer';
import ExpandedComponent from './ExpandedComponent';
import { useSelectedLog } from 'hooks/useOrganizationLoggingHook';

const OrganizationLoggingTable = () => {
    const navigate = useNavigate(),
        { data = {} } = useSelectedLog(),
        results = data?.results || [],
        totalResults = data?.totalNumberOfResults || results?.length || 0,
        itemsPerPage = data?.resultSetSize || totalResults?.length || 10,
        [sorts, setSorts] = useState({});

    /**
     * @param columnInfo
     * @param direction
     */
    const handleSorts = async (columnInfo, direction) => {
        const sortData = { [columnInfo.fieldName]: direction === 'asc' ? 1 : -1 };
        setSorts(sortData);

        await fetchLogs({ pageNo: 1, sorts: sortData });
    };

    /**
     * Handle items per page change
     */
    const handleItemsPerPageChange = async (pageLimit) => {
        fetchLogs({
            pageNo: 1,
            limit: pageLimit,
            sorts,
        });
    };

    const handlePageChange = async (newPage) => {
        fetchLogs({ pageNo: newPage, sorts });
    };

    const expandedIcons = {
        expanded: <ExpandMoreIcon color="primary" className="toggleLogBtnSvg" />,
        collapsed: <ChevronRightIcon color="primary" className="toggleLogBtnSvg" />,
    };

    const itemsPerPageList = [10, 20, 30, 40, 50],
        containerProps = { unmountTable: true };

    const renderTableColumns = TableColumns({
        navigate,
    });

    return (
        <Box sx={styles.container}>
            <TableContainer
                containerProps={containerProps}
                paginationRowsPerPageOptions={itemsPerPageList}
                expandableRowsComponent={ExpandedComponent}
                paginationTotalRows={totalResults}
                paginationPerPage={itemsPerPage}
                expandableRows={false}
                expandableIcon={expandedIcons}
                paginationServer={true}
                onChangePage={handlePageChange}
                emptyDataText="No log found"
                columns={renderTableColumns}
                style={styles.tableContainer({ isLoading: false })}
                data={results}
                onSort={handleSorts}
                sortServer={true}
                defaultSortFieldId={null}
                onChangeRowsPerPage={handleItemsPerPageChange}
            />
        </Box>
    );
};

export default memo(OrganizationLoggingTable);
